import { render, staticRenderFns } from "./card-members.vue?vue&type=template&id=7bdb88e3&"
import script from "./card-members.vue?vue&type=script&lang=ts&"
export * from "./card-members.vue?vue&type=script&lang=ts&"
import style0 from "./card-members.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports